import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import { useParameterContext } from "../../../../context/ParameterContext";
import useCustomEffect from "../../../../hooks/useCustomEffect";
import EmployeeStepView from "./EmployeeStepView";
import StringHelper from "../../../../helpers/StringHelper";

function EmployeeStep({ controller }) {
  const [search, setSearch] = useState("");
  const callEvaApi = useEvaApi();
  const { getParameter } = useParameterContext();
  const selectedEmployee = controller.fetchedEntities.employees?.find(
    (emp) => parseInt(emp.id) === parseInt(controller.visitorData.employee_id),
  );

  /**
   * UseEffect for automatically fetching the employees if it's not set
   */
  useCustomEffect(() => {
    fetchEmployees();
  });

  /**
   * This method will fetch the employees from the API
   */
  async function fetchEmployees() {
    await callEvaApi(
      new EvaApiCall("employees")
        .setLoadingGroup("visitor_type_page_fetch")
        .setParams({
          where: [
            {
              column: "id",
              values: [
                {
                  operator: "not in",
                  value: controller.fetchedEntities.employees.map(
                    (employee) => employee.id,
                  ),
                },
              ],
            },
          ],
        })
        .setOnSuccess((response) => {
          controller.setFetchedEntities((prev) => ({
            ...prev,
            employees: [...prev.employees, ...response.data.data.records],
          }));
        }),
    );
  }

  /**
   * This method will handle the employee id change event
   * @param {any} value
   */
  function onEmployeeIdChange(value) {
    controller.setVisitorData((prev) => ({ ...prev, employee_id: value }));
  }

  /**
   * This method will return the employee options
   * @returns {Array}
   */
  function getEmployeeOptions() {
    if (
      controller.fetchedEntities.employees &&
      search.length >=
        parseInt(getParameter("name.search.min.chars")?.value ?? 3)
    ) {
      return controller.fetchedEntities.employees
        .filter((emp) => StringHelper.matchesSearch(emp.name, search))
        .map((emp) => ({ value: emp.id, label: emp.name }));
    } else if (selectedEmployee) {
      return [
        {
          value: selectedEmployee.id,
          label: selectedEmployee.name,
        },
      ];
    } else {
      return [];
    }
  }

  return (
    <EmployeeStepView
      controller={controller}
      employeeOptions={getEmployeeOptions()}
      setSearch={setSearch}
      onEmployeeIdChange={onEmployeeIdChange}
    />
  );
}

export default EmployeeStep;
